import CommonDialog from '../commonDialog'
import TestDialog from '../testDialog'
import SvgIcon from '../svgIcon'
import SiteRichText from '../siteRichText'

// 批量注册全局组件
const components = {
  CommonDialog,
  TestDialog,
  SvgIcon,
  SiteRichText
}

export default {
  install(Vue) {
    Object.keys(components).forEach(key => {
      console.log(key, components[key])
      if (!Vue.options.components[key]) {
        Vue.component(key, components[key])
      }
    })
  }
}
